import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/crossword.json";
import fr from "@/locales/fr/puzzle-types/crossword.json";

export const CROSSWORD_NS = "puzzle-types/crossword";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerCrosswordTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", CROSSWORD_NS))
    i18n.addResourceBundle("en", CROSSWORD_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", CROSSWORD_NS))
    i18n.addResourceBundle("fr", CROSSWORD_NS, fr, true, true);
}
